import { TenantsAPI } from 'src/apis/tenantsAPI';

import Fetcher from '../fetcher';

const api = new TenantsAPI();

export const TenantsFetcher = new Fetcher('tenants/list', async () => api.getTenants());
